// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"cd76e2a7","234":"a65e5a5d","664":"f9f8b4f8","974":"e9043977"}[chunkId] + ".chunk.css";
};